import { ColumnsType } from "antd/es/table";
import AntTable from "../../../components/table/Table";
import { Modal } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { PaymentService } from "../../../services/PaymentService";
import { useState } from "react";
import Filter from "./Filter";
import EditMember from "./../../member/EditMember";
import moment from "moment";



export default function Transaction() {

    const [isModalOpenUser, setIsModalOpenUser] = useState<boolean>(false);
    const [editRecordUser, setEditRecordUser] = useState<any>()
    const [refreshData, setRefreshData] = useState<boolean>(false)
    const [filters, setFilters] = useState<any>()



    const columns: ColumnsType<any> = [
        {
            title: 'วันที่ทำรายการ',
            align: 'center',
            dataIndex: 'trx_created_date',
            key: 'trx_created_date',
            render: (value, record) => {
                return moment(value).isValid() ? moment(value).format('DD-MM-YYYY HH:mm') : ''
            },
        },
        {
            title: 'Client Member Id',
            align: 'center',
            dataIndex: 'client_member_id',
            key: 'client_member_id',
            render: (value, record) => {

                return <div
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={() => {
                        setEditRecordUser({
                            id: record?.user_id,
                            fullname: record?.fullname
                        })
                        setIsModalOpenUser(true)
                    }}>{value}</div>
            }
        },
        {
            title: 'Client Phone Number',
            align: 'center',
            dataIndex: 'client_phone_no',
            key: 'client_phone_no',
            render: (value, record) => {
                return `${value}`
            }
        },
        {
            title: 'Transaction ID',
            align: 'center',
            dataIndex: 'transaction_id',
            key: 'transaction_id'
        },
        {
            title: 'Send Amount',
            align: 'center',
            sorter: true,
            dataIndex: 'send_amount',
            key: 'send_amount',

            render: (value: number, record) => {
                return `${(+value).toLocaleString('en-US', { minimumFractionDigits: 2 })} ${record?.send_currency}`
            }
        },
        {
            title: 'Receive Amount',
            align: 'center',
            sorter: true,
            dataIndex: 'receive_amount',
            key: 'receive_amount',
            render: (value, record) => {
                return `${(+value).toLocaleString('en-US', { minimumFractionDigits: 2 })} ${record?.receive_currency}`
            }
        },
        {
            title: 'Fee',
            align: 'center',
            dataIndex: 'fee',
            key: 'fee',
            render: (value, record) => {
                return `${(+value).toLocaleString('en-US', { minimumFractionDigits: 2 })}`
            }
        },
        {
            title: 'Referral Code',
            align: 'center',
            dataIndex: 'referral_code',
            key: 'referral_code'
        },
        {
            title: 'สถานะ',
            align: 'center',
            filters: [
                {
                    text: 'Completed',
                    value: "'Completed'",
                },
                {
                    text: 'Processing',
                    value: "'Processing'",
                },
                {
                    text: 'Canceled',
                    value: "'Canceled'",
                },

            ],
            dataIndex: 'transaction_status',
            key: 'transaction_status',
            render: (value, record) => {
                return value
            },
        },
    ];


    const onLoadData = async (params: any = {}) => {

        const payload = {
            ...params,
            ...filters
        }
        const res = await PaymentService.getPaymentTransactions(payload)
        return res
    }

    const exportReport = async () => {
        const data = {
            month: filters.month,
            year: filters.year
        }
        await PaymentService.exportPaymentTransactions(data)
    }

    const onFilters = (data: object) => {
        setFilters(data)
        setRefreshData(p => !p)
    }


    return (
        <>

            <Modal
                title=""
                width={900}
                open={isModalOpenUser}
                onOk={() => setIsModalOpenUser(true)}
                onCancel={() => setIsModalOpenUser(false)}
                footer={null}>
                <EditMember
                    record={editRecordUser}
                    onFinish={() => {
                        setIsModalOpenUser(false)
                    }}
                ></EditMember>
            </Modal>
            <AntTable 
                Filter={<Filter setFilters={onFilters} />}
                refresh={refreshData}
                menuOptions={[{
                    label: `Export Excel - ${filters?.year && moment().set('month', filters?.month - 1).year(filters?.year).format('MMMM YYYY')}`,
                    key: 'export'
                }]}
                menuClick={(e) => {
                    if (e.key == 'export') {
                        exportReport();
                    }
                }}
                search
                title="Payment Transaction"
                columns={columns}
                onLoadData={onLoadData}
            />
        </>

    )
}